<form [formGroup]="form" class="bg-white rounded shadow-lg overflow-hidden" (ngSubmit)="onSave()">
  <div class="bg-red-700 text-white px-6 py-3 text-lg font-semibold">Create New CA Number:</div>
  <div class="px-6 py-4 flex flex-col gap-2">
    <div class="text-gray-700 text-sm mb-2">
      An entry in the PRODUCT DATABASE will be saved with the details of this Order.<br />
      <span class="font-semibold">Please create a unique, new CA Number below to save.</span>
    </div>
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>New CA#</mat-label>
      <input matInput formControlName="caNumber" autocomplete="off" maxlength="32" />
    </mat-form-field>
    <div
      *ngIf="
        form.get('caNumber')?.invalid &&
        (form.get('caNumber')?.dirty || form.get('caNumber')?.touched)
      "
      class="text-xs text-red-600"
    >
      CA Number is required.
    </div>
    <div *ngIf="getErrorMessage()" class="text-xs text-red-600">{{ getErrorMessage() }}</div>
    <div class="flex justify-end items-center mt-4 gap-4">
      <button mat-flat-button type="button" (click)="onCancel()" class="text-blue-600">
        CANCEL
      </button>
      <button
        mat-flat-button
        color="primary"
        type="submit"
        [disabled]="form.invalid || submitting()"
        class="!bg-green-600 !hover:bg-green-700 !text-white font-semibold shadow-md"
      >
        <ng-container *ngIf="!submitting(); else loading">SAVE NEW CA NUMBER</ng-container>
        <ng-template #loading>
          <div class="flex items-center gap-2">
            <mat-spinner diameter="20"></mat-spinner>
            <span>Saving...</span>
          </div>
        </ng-template>
      </button>
    </div>
  </div>
</form>
